import { ShieldCheck, Building2, ClipboardCheck, BadgeCheck, MapPin } from "lucide-react";
import { Reveal } from "./Reveal";

const ITEMS = [
  { icon: ShieldCheck, label: "Licensed & Insured" },
  { icon: Building2, label: "Residential & Commercial" },
  { icon: ClipboardCheck, label: "Free Estimates" },
  { icon: BadgeCheck, label: "Lifetime Warranty Available" },
  { icon: MapPin, label: "Locally Owned" },
];

export default function TrustBar() {
  return (
    <div className="relative z-20 -mt-24 px-4 md:px-8">
      <Reveal className="max-w-6xl mx-auto">
        <div
          data-testid="trust-bar"
          className="glass-dark rounded-2xl grid grid-cols-2 md:grid-cols-5 divide-x divide-y md:divide-y-0 divide-white/10 overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.5)]"
        >
          {ITEMS.map((item, i) => (
            <div
              key={item.label}
              data-testid={`trust-item-${i}`}
              className="flex items-center gap-3 px-5 py-6 group hover:bg-white/5 transition-colors duration-300"
            >
              <item.icon size={22} className="text-cyan-400 shrink-0 drop-shadow-[0_0_8px_rgba(0,229,255,0.5)]" />
              <span className="text-[13px] font-bold leading-tight text-gray-200 group-hover:text-white transition-colors duration-300">
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  );
}
